import React, { Component } from 'react';

import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';
import { get } from 'lodash';

import {
  getDataFilters,
  updateFormNegoce,
  getDataPresentationKpis
} from '../../../actions/negoce';
import { formatDataOptions } from '../helper';

import Negoce from '../index';
import NegoceFilters from '../components/NegoceFilter';
import KeyIndicatorsCardContainer from '../components/KeyIndicatorsCard';
import ExportButton from '../../../components/Export/Button';
import Card from '../../../components/Card';
import Spinner from '../../../components/Spinner';
import { useUserMe } from '../../../apiTyped/hooks/users.query';

const NegoceContainer = styled.div`
  .negoceRowContainer {
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-gap: 25px;
  }

  .presentationContentContainer {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin-bottom: 20px;
  }

  .rankFlag {
    color: #f4501c;
  }
`;

class Presentation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  async componentDidMount() {
    await this.formatDataFilters();
    this.findPresentation();
  }

  async formatDataFilters() {
    await this.props.getDataFilters();
    [
      {
        type: 'currentWine',
        data: this.props.wines || [],
        keys: {
          value: 'wine_id',
          label: 'wine_name'
        }
      },
      {
        type: 'currentCampaign',
        data: this.props.campaigns || [],
        keys: {
          value: 'campaign_id',
          label: 'campaign_name'
        }
      },
      {
        type: 'currentNegociant',
        data: this.props.negociants || [],
        keys: {
          value: 'negociant_id',
          label: 'negociant_name'
        }
      }
    ].map((filterParams) => {
      this.setDefaultFilter(filterParams);
    });
  }

  setDefaultFilter({ type, data, keys }) {
    const { updateFormNegoce, form } = this.props;
    const typeExist = get(form, type);
    if (!typeExist) {
      const { value, label } = keys;
      const defaultOptions = data.find(({ is_default }) => is_default === true);
      if (defaultOptions) {
        updateFormNegoce({
          [type]: {
            value: get(defaultOptions, value),
            label: get(defaultOptions, label)
          }
        });
      }
    }
  }

  async handleChangeFilters({ type, data }) {
    this.setState({ loading: true });

    if (get(this.props.form, type)) {
      this.setDefaultFilter({
        type,
        data,
        keys: {
          value: 'sale_type_id',
          label: 'sale_type_name'
        }
      });
    }

    await this.props.updateFormNegoce({
      [type]: data
    });
    return this.findPresentation();
  }

  async findPresentation() {
    this.setState({ loading: true });
    const campaignId = get(this.props.currentCampaign, 'value') || -1;
    const negociantId = get(this.props.currentNegociant, 'value') || -1;
    const wineId = get(this.props.currentWine, 'value') || -1;
    await this.props.getDataFilters(campaignId, 'negociant');

    await this.props.getDataPresentationKpis({
      campaignId,
      negociantId,
      wineId
    });

    this.setState({ loading: false });
  }

  formatKpisPrimeurs() {
    const primeursKpis = get(this.props.kpis, 'primeurs_kpis', []);
    const formatedKpi = [
      {
        title: (
          <>
            <p className="rankFlag">
              {get(primeursKpis, 'negociant_rank') || ' '}
            </p>
            <p>
              {get(primeursKpis, 'quantity_eq_75', ' ')}{' '}
              {get(primeursKpis, 'quantity_eq_75_over_pool_pct') || ' '}
            </p>
          </>
        ),
        content: I18n.t('negoce.presentation.kpis.primeurs.quantityEq75')
      },
      {
        title: get(primeursKpis, 'nb_customers') || ' ',
        content: I18n.t('negoce.presentation.kpis.primeurs.nbCustomers')
      },
      {
        title: (
          <>
            <p className="rankFlag">
              {get(primeursKpis, 'negociant_rank_n1') || ' '}
            </p>
            <p>
              {get(primeursKpis, 'quantity_eq_75_n1', ' ')}{' '}
              {get(primeursKpis, 'quantity_eq_75_over_pool_pct_n1') || ' '}
            </p>
          </>
        ),
        content: I18n.t('negoce.presentation.kpis.primeurs.quantityEq75n1')
      },
      {
        title: `${get(primeursKpis, 'customer_exclusivity_pct') || ' '}`,
        content: I18n.t(
          'negoce.presentation.kpis.primeurs.customerExclusivityPct'
        )
      },
      {
        title: `${get(
          primeursKpis,
          'quantity_eq_75_over_allocation_pct',
          ' '
        )}`,
        content: I18n.t(
          'negoce.presentation.kpis.primeurs.quantityEq75OverAllocationPct'
        )
      },
      {
        title: `${get(primeursKpis, 'customer_recurring_pct') || ' '}`,
        content: I18n.t(
          'negoce.presentation.kpis.primeurs.customerRecurringPct'
        )
      }
    ];
    return formatedKpi;
  }

  formatKpisLivrables() {
    const livrablesKpis = get(this.props.kpis, 'livrables_kpis', []);
    const formatedKpi = [
      {
        title: (
          <>
            <p className="rankFlag">
              {get(livrablesKpis, 'negociant_rank') || ' '}
            </p>
            <p>
              {get(livrablesKpis, 'quantity_eq_75', ' ')}{' '}
              {get(livrablesKpis, 'quantity_eq_75_over_pool_pct') || ' '}
            </p>
          </>
        ),
        content: I18n.t('negoce.presentation.kpis.primeurs.quantityEq75')
      },
      {
        title: get(livrablesKpis, 'nb_customers') || ' ',
        content: I18n.t('negoce.presentation.kpis.primeurs.nbCustomers')
      },
      {
        title: (
          <>
            <p className="rankFlag">
              {get(livrablesKpis, 'negociant_rank_n1') || ' '}
            </p>
            <p>
              {get(livrablesKpis, 'quantity_eq_75_n1', ' ')}{' '}
              {get(livrablesKpis, 'quantity_eq_75_over_pool_pct_n1') || ' '}
            </p>
          </>
        ),
        content: I18n.t('negoce.presentation.kpis.primeurs.quantityEq75n1')
      },
      {
        title: `${get(livrablesKpis, 'customer_exclusivity_pct') || ' '}`,
        content: I18n.t(
          'negoce.presentation.kpis.primeurs.customerExclusivityPct'
        )
      },
      {
        title: `${
          get(livrablesKpis, 'quantity_eq_75_over_allocation_pct') || ' '
        }`,
        content: I18n.t(
          'negoce.presentation.kpis.primeurs.quantityEq75OverAllocationPct'
        )
      },
      {
        title: `${get(livrablesKpis, 'customer_recurring_pct') || ' '}`,
        content: I18n.t(
          'negoce.presentation.kpis.primeurs.customerRecurringPct'
        )
      }
    ];
    return formatedKpi;
  }

  render() {
    const campaignsData = this.props.campaigns || [];
    const winesData = this.props.wines || [];
    const negociantsData = this.props.negociants || [];
    const campaignId = get(this.props.currentCampaign, 'value');
    const negociantId = get(this.props.currentNegociant, 'value');
    const availablePresentations = this.props.availablePresentations || [];
    const userLang = get(this.props, 'userLang');

    const formatDataKpisPrimeurs = this.formatKpisPrimeurs() || [];
    const formatDataKpisLivrables = this.formatKpisLivrables() || [];

    const optionsCampaign = formatDataOptions(campaignsData, {
      value: 'campaign_id',
      label: 'campaign_name'
    });
    const optionsWine = formatDataOptions(winesData, {
      value: 'wine_id',
      label: 'wine_name'
    });
    const optionsNegociants = formatDataOptions(negociantsData, {
      value: 'negociant_id',
      label: 'negociant_name'
    });

    const exports = ['xls'].concat(availablePresentations);

    const defaultCampain = optionsCampaign[0];
    const defaultCampainId = defaultCampain?.value;

    return (
      <Negoce>
        <NegoceContainer>
          <Card>
            <div className="negoceRowContainer">
              <NegoceFilters
                wineFilter={{
                  selectedOption: this.props.currentWine,
                  options: optionsWine,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentWine',
                      data: value
                    });
                  },
                  label: I18n.t('negoce.filters.wines'),
                  placeholder: I18n.t('negoce.filters.winesPlaceholder')
                }}
                campaignFilter={{
                  selectedOption: this.props.currentCampaign || defaultCampain,
                  options: optionsCampaign,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentCampaign',
                      data: value
                    });
                  },
                  label: I18n.t('negoce.filters.date'),
                  placeholder: I18n.t('negoce.filters.datePlaceholder')
                }}
                negociantsFilter={{
                  selectedOption:
                    optionsNegociants.length > 0 && this.props.currentNegociant,
                  options: optionsNegociants,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentNegociant',
                      data: value
                    });
                  },
                  label: I18n.t('negoce.filters.negociants'),
                  placeholder: I18n.t('negoce.filters.negociantsPlaceholder')
                }}
              />
              <ExportButton
                options={exports}
                paths={{
                  xls: `/negociant/campaign/${
                    campaignId || defaultCampainId
                  }/negociant/${negociantId}/export`,
                  ppt: `/negociant/campaign/${
                    campaignId || defaultCampainId
                  }/ppt_export`
                }}
                params={{
                  ppt: {
                    document_type: 'negociant',
                    negociant_id: negociantId,
                    lang: userLang
                  }
                }}
                newApi
              />
            </div>
          </Card>
          <div className="presentationContentContainer">
            <KeyIndicatorsCardContainer
              title={I18n.t('negoce.presentation.kpis.primeurs.title')}
              indicators={formatDataKpisPrimeurs}
            />
            <KeyIndicatorsCardContainer
              title={I18n.t('negoce.presentation.kpis.livrables.title')}
              indicators={formatDataKpisLivrables}
            />
            <Spinner loading={this.state.loading} />
          </div>
        </NegoceContainer>
      </Negoce>
    );
  }
}

const Index = (props) => {
  const { user } = useUserMe();
  return <Presentation {...props} userLang={user.language} />;
};

const mapStateToProps = (state) => {
  return {
    kpis: state.negoce.data.presentation_kpis,
    campaigns: state.negoce.data.campaigns,
    wines: state.negoce.data.wines,
    negociants: state.negoce.data.negociants,
    availablePresentations: state.negoce.data.available_presentations,
    currentCampaign: state.negoce.form.currentCampaign,
    currentWine: state.negoce.form.currentWine,
    currentNegociant: state.negoce.form.currentNegociant,
    form: state.negoce.form
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDataFilters: (campaignId, presentationType) =>
      dispatch(getDataFilters(campaignId, presentationType)),
    updateFormNegoce: (data) => dispatch(updateFormNegoce(data)),
    getDataPresentationKpis: ({ campaignId, negociantId, wineId }) =>
      dispatch(getDataPresentationKpis({ campaignId, negociantId, wineId }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
